"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDestinationClient = void 0;
var BaseUrl_1 = require("../BaseUrl");
var __1 = require("..");
var baseUrl = new BaseUrl_1.BaseUrl({ url: "" });
var setBaseUrl = function (url) {
    baseUrl.url = url;
};
var getOneById = function (orderDestinationId) {
    var url = baseUrl.url + "/order-destinations/" + orderDestinationId;
    return fetch(url).then(function (response) { return response.json(); });
};
var getAllByLocation = function (locationId, authToken) {
    var url = baseUrl.url + "/order-destinations?locationId=" + locationId;
    return fetch(url, {
        headers: {
            "Authorization": authToken,
        },
    }).then(function (response) { return response.json(); });
};
var create = function (odDto, authToken) {
    var url = baseUrl.url + "/order-destinations";
    return fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": authToken,
        },
        body: JSON.stringify(odDto),
    }).then(function (response) { return response.json()
        .then(function (data) { return new __1.OrderDestination(data); }); });
};
var remove = function (orderDestinationId, authToken) {
    var url = baseUrl.url + "/order-destinations/" + orderDestinationId;
    return fetch(url, {
        method: "DELETE",
        headers: {
            "Authorization": authToken,
        },
    }).then(function (response) { return response; });
};
exports.OrderDestinationClient = {
    setBaseUrl: setBaseUrl,
    getOneById: getOneById,
    getAllByLocation: getAllByLocation,
    create: create,
    remove: remove,
};
